import Text from 'components/Text/Text';
import React from 'react';
import breadcrumbs from 'assets/img/breadcrumbs.svg';
import classNames from 'classnames';
import style from './DeleteButton.module.scss';

interface IDeleteBtn {
	idForDeletion: string;
	filePath: string | null;
	deleteBankSettingsFIle: (value: string) => void;
}

const DeleteBtn: React.FC<IDeleteBtn> = ({ idForDeletion, filePath, deleteBankSettingsFIle }) => {
	const buttonClasses = classNames(style.button, { [style.disabled]: !filePath });

	const handleDelete = () => {
		deleteBankSettingsFIle(idForDeletion);
	};

	return (
		<div className={style.container}>
			<div className={buttonClasses} onClick={handleDelete}>
				<div className={style.label}>
					<svg className={style.icon}>
						<use xlinkHref={`${breadcrumbs}#bin`} />
					</svg>
					<Text translationNameSpace="form" translationKey="deleteSettingsButton" asFragment={true} />
				</div>
			</div>
		</div>
	);
};

export default React.memo(DeleteBtn);
